
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCellLow as ObiCellLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cell-low.js';
 
 
 

 
 export const ObiCellLow = createComponent({
   react: React,
   tagName: 'obi-cell-low',
   elementClass: ObiCellLowElement,
   events: {
     
   }
  });
 
 